// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.time-grid-wrapper {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 12px;
  justify-content: center;
  margin-bottom: 1rem;
}

.time-button {
  font-family: AppFontBold, sans-serif;
  border: 2px solid #000;
  border-radius: 12px;
  padding: 12px 0;
  background-color: white;
  cursor: pointer;
  text-align: center;
  font-size: 16px;
  transition: all 0.2s ease-in-out;
}

.time-button.selected {
  border-color: #9c774d;
  background-color: #f9f5f0;
}

.toggle-button {
  text-align: center;
  font-family: AppFontBold, sans-serif;
  cursor: pointer;
  font-size: 14px;
  color: #000;
  text-decoration: none;
  margin-top: 1rem;
  transition: opacity 0.2s;
  border: 2px solid;
  padding: 12px;
  border-radius: 11px;
}

.header-color {
  font-family: AppFontBold, sans-serif;
  font-size: 18px;
  margin-bottom: 1rem;
  text-align: center;
}

.eintracht .time-button {
  color: #000;
}
.eintracht .time-button.selected {
  border-color: #E30613;
}
.eintracht .toggle-button {
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/app/components/select-date-formcontrol/select-date-formcontrol.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EAEA,qCAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,oCAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;AAAF;;AAGA;EACE,qBAAA;EACA,yBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,oCAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,wBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;AAAF;;AAGA;EACE,oCAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AAAF;;AAIE;EACE,WAAA;AADJ;AAEI;EACE,qBAAA;AAAN;AAGE;EACE,WAAA;AADJ","sourcesContent":[".time-grid-wrapper {\n  display: grid;\n  // grid-template-columns: repeat(2, 1fr); // zwei Spalten\n  grid-template-columns: repeat(1, 1fr);\n  gap: 12px;\n  justify-content: center;\n  margin-bottom: 1rem;\n}\n\n.time-button {\n  font-family: AppFontBold, sans-serif;\n  border: 2px solid #000;\n  border-radius: 12px;\n  padding: 12px 0;\n  background-color: white;\n  cursor: pointer;\n  text-align: center;\n  font-size: 16px;\n  transition: all 0.2s ease-in-out;\n}\n\n.time-button.selected {\n  border-color: #9c774d;\n  background-color: #f9f5f0;\n}\n\n.toggle-button {\n  text-align: center;\n  font-family: AppFontBold, sans-serif;\n  cursor: pointer;\n  font-size: 14px;\n  color: #000;\n  text-decoration: none;\n  margin-top: 1rem;\n  transition: opacity 0.2s;\n  border: 2px solid;\n  padding: 12px;\n  border-radius: 11px;\n}\n\n.header-color {\n  font-family: AppFontBold, sans-serif;\n  font-size: 18px;\n  margin-bottom: 1rem;\n  text-align: center;\n}\n\n.eintracht {\n  .time-button {\n    color:#000;\n    &.selected {\n      border-color: #E30613;\n    }\n  }\n  .toggle-button {\n    color: #fff;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
